export enum ProductType {
  GiftCard = 'giftCard',
}

export enum OrderStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

export type Recipient = {
  name: string
  email: string
  phoneNumber: string
  scheduledAt: Date | null
}

export enum GiftCardType {
  Personal = 'personal',
  Gift = 'gift',
}

export type GiftCardOptions = {
  recipientType: GiftCardType
  amount: number | 25_00 | 50_00 | 75_00 | 100_00
  quantity: number
  purchaserId: string // uid of user who bought the gift card
  senderName: string | null // custom name set in gift card purchase if purchased for others
  customMessage: string | null
  recipient: Recipient | null
}
